import { render, staticRenderFns } from "./WalletOverview.vue?vue&type=template&id=67ea0626&scoped=true&"
import script from "./WalletOverview.vue?vue&type=script&lang=js&"
export * from "./WalletOverview.vue?vue&type=script&lang=js&"
import style0 from "./WalletOverview.vue?vue&type=style&index=0&id=67ea0626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ea0626",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VDivider,VIcon,VTextField})
